<template >
  <div class="o-component o-component--expand">
    <div class="a-layout a-layout--center">
      <div class="u-col-span:4@md" v-for="callToActionBlock of props.callToActions">
        <a :href="callToActionBlock.link ?? '#'" class="m-content-card is-link with-gradient">
          <div class="m-content-card__image">
            <picture class="a-image" style="--padding-ratio: calc(4 / 3)">
              <img class="a-image__img m-content-card__img"
              :src="callToActionBlock.image.thumbURL + '?width=5&height=5'"
              :data-src="callToActionBlock.image.thumbURL + '?width=300&height=400'"
              :alt="callToActionBlock.image.alt" loading="lazy"/>
            </picture>
            <h2 class=" m-content-card__title a-h3">{{ callToActionBlock.title }}</h2>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { CallToActionBlock } from '../../helper/article';

const props = defineProps({
  callToActions: {
    type: Array<CallToActionBlock>,
    default: [],
    required: true,
  },
})


</script>
